var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPuzzlePiece(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M24 14.846c0 1.31-.737 2.405-2.098 2.405-1.523 0-1.923-1.413-3.296-1.413-2.313 0-.987 4.692-.987 4.692-1.969 0-6.922 1.37-6.922-1.005 0-1.4 1.386-1.807 1.386-3.36 0-1.386-1.074-2.137-2.36-2.137-1.31 0-2.428.738-2.428 2.201 0 1.616 1.528 2.305 1.528 3.183 0 2.722-6.823 1.12-6.823 1.12V7.514s6.718 1.602 6.718-1.12c0-.877-1.212-1.577-1.212-3.193C7.506 1.738 8.718 1 10.041 1c1.274 0 2.348.75 2.348 2.138 0 1.552-1.386 1.959-1.386 3.36 0 3.252 7.497.127 7.497.127s-2.085 6.885.205 6.885c.862 0 1.549-1.234 3.135-1.234 1.434 0 2.16 1.234 2.16 2.57z"
  }))));
}

export default SvgPuzzlePiece;